<div *ngIf="!!element" class="edit-contact-dialog">
  <mat-form-field class="title">
    <mat-label>{{'general.title' | translate}}</mat-label>
    <input [(ngModel)]="element.title" matInput>
  </mat-form-field>
  <ng-container *ngIf="data.type === 'contact'">
    <mat-form-field>
      <mat-label>{{'contact.website' | translate}}</mat-label>
      <input [(ngModel)]="element.website" matInput>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'contact.email' | translate}}</mat-label>
      <input [(ngModel)]="element.email" matInput>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'contact.phone' | translate}}</mat-label>
      <input [(ngModel)]="element.phone" matInput>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'contact.fax' | translate}}</mat-label>
      <input [(ngModel)]="element.fax" matInput>
    </mat-form-field>
  </ng-container>
  <ng-container *ngIf="data.type ===  'address'">
    <mat-form-field>
      <mat-label>{{'contact.street' | translate}}</mat-label>
      <input [(ngModel)]="element.street" matInput>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'contact.zip' | translate}}</mat-label>
      <input [(ngModel)]="element.zip" matInput>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'contact.city' | translate}}</mat-label>
      <input [(ngModel)]="element.city" matInput>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'contact.lat' | translate}}</mat-label>
      <input [(ngModel)]="element.coordinates.latitude" matInput type="number">
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'contact.lng' | translate}}</mat-label>
      <input [(ngModel)]="element.coordinates.longitude" matInput type="number">
    </mat-form-field>
  </ng-container>

  <div class="button-right-container">
    <button (click)="save()" [disabled]="checkFields" [class.mat-button-disabled]="checkFields"
            class="ibexfusion-raised-button" mat-button>{{ 'general.save' | translate }}</button>
  </div>
</div>
